import { SubscriptionStatus } from "../../../types/subscription";

const STYLES: Record<string, { bg: string; fg: string }> = {
  ACTIVE: { bg: "#d4edda", fg: "#155724" },
  UNPAID: { bg: "#f8d7da", fg: "#721c24" },
  PAUSED: { bg: "#fff3cd", fg: "#856404" },
  DISABLED: { bg: "#e9ecef", fg: "#495057" },
  PENDING: { bg: "#e7f1ff", fg: "#0a58ca" },
};

const FALLBACK = { bg: "#e9ecef", fg: "#495057" };

export default function SubscriptionStatusBadge({
  status,
}: {
  status: SubscriptionStatus;
}) {
  const s = STYLES[status] ?? FALLBACK;
  return (
    <span
      style={{
        display: "inline-block",
        padding: "0.2rem 0.6rem",
        borderRadius: "999px",
        fontSize: ".75rem",
        fontWeight: 700,
        letterSpacing: ".5px",
        background: s.bg,
        color: s.fg,
        whiteSpace: "nowrap",
      }}
    >
      {status || "—"}
    </span>
  );
}
